import { Combobox } from '@consta/uikit/Combobox'
import { Text } from '@consta/uikit/Text'
import {
  selectKsuCompanies,
  updateGeoDbCompanyLists,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { KsuCompany, KsuField, KsuLicenseArea } from '@core/core/types'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import type { GeoDbSearchFiltersProps as Props } from '../types'
import css from './DBSearchFiltersGeoDb.css'

const textWidth = { width: '8rem' }

export const DBSearchFiltersGeoDb: FC<Props> = ({
  query,
  companyChanged,
  fieldChanged,
  licenseAreaChanged,
}) => {
  const companies = useAppSelector(selectKsuCompanies)

  const dispatch = useAppDispatch()
  const onCompanyChange = (value: Nullable<KsuCompany>) => {
    if (value && !value.fields && !value.licenseAreas) {
      dispatch(updateGeoDbCompanyLists(value.ksuUid))
    }
    companyChanged(value?.ksuUid)
  }
  const onFieldChange = (value: Nullable<KsuField>) => {
    fieldChanged(value?.ksuUid)
  }
  const onLicenseAreaChange = (value: Nullable<KsuLicenseArea>) => {
    licenseAreaChanged(value?.ksuUid)
  }

  const activeCompany = companies.find(company => company.ksuUid === query?.company)
  const activeField = activeCompany?.fields?.find(field => field.ksuUid === query?.field)
  const activeLicenseArea = activeCompany?.licenseAreas?.find(
    area => area.ksuUid === query?.licenseArea,
  )

  return (
    <div className={css.container}>
      <Text size="s" view="secondary" align="right" style={textWidth} className={css.text}>
        ГеоБД
      </Text>

      <Combobox
        size="s"
        placeholder="ДО"
        items={companies}
        getItemKey={i => i.ksuUid}
        getItemLabel={i => i.name}
        required={true}
        value={activeCompany}
        className={css.field}
        data-testid="companiesCombo"
        data-analytics-id="new import_search"
        onChange={onCompanyChange}
      />
      <Combobox
        placeholder="Месторождение"
        size="s"
        items={activeCompany?.fields ?? []}
        getItemKey={i => i.ksuUid}
        getItemLabel={i => i.name}
        required={true}
        className={css.field}
        value={activeField}
        data-testid="fieldsCombo"
        onChange={onFieldChange}
      />
      <Combobox
        placeholder="Лицензионный участок"
        size="s"
        items={activeCompany?.licenseAreas ?? []}
        getItemKey={i => i.ksuUid}
        getItemLabel={i => i.name}
        required={true}
        className={css.field}
        value={activeLicenseArea}
        data-testid="licenseAreasCombo"
        onChange={onLicenseAreaChange}
      />
    </div>
  )
}
